/**
 * Determines if an HTML element is a text element that should become contentEditable.
 *
 * An element is considered a text element if:
 * 1. It has non-empty innerText
 * 2. It has direct text node children (not just text nested in child elements)
 *
 * This ensures we only make elements editable when they directly contain text,
 * rather than container elements that have text in nested children.
 */
export function isTextElement(element: HTMLElement): boolean {
  const text = element.innerText.trim();
  if (!text) return false;

  // Check for direct text node children
  return Array.from(element.childNodes).some(
    (node) => node.nodeType === Node.TEXT_NODE && node.textContent?.trim(),
  );
}
